import React, { useContext, ReactElement, useEffect } from 'react';

import HeaderContext from '../../HeaderContext';

import { useUserMenuQueryLazyQuery } from './UserMenu.generated';
import RenderUserMenu from './RenderUserMenu';

// TODO: Rewrite this in local scope after gettig translations
import getUserLinks from '../../../components/UserDropDown/getUserLinks';

const parseUsername = (username: string) =>
  username.length > 15 ? `${username.substring(0, 9)}...` : username;

const UserMenu = (): ReactElement | null => {
  const { lang, isEUDC } = useContext(HeaderContext);

  const [fetch, { loading, error, data }] = useUserMenuQueryLazyQuery();
  useEffect(() => {
    fetch();
  }, []);

  if (loading) {
    return null;
  }

  if (error || !data?.user) {
    const userLinks = getUserLinks();
    return <RenderUserMenu username="My Account" menuItems={userLinks} />;
  }
  const {
    username,
    preferences,
    features,
    linkedIdentities,
    teamMembership,
  } = data.user;

  const isTeamOwner = teamMembership?.memberType === 'ACCOUNT_OWNER';
  const isEnterpriseAccount = teamMembership?.isEnterprise;
  const isNonEnterpriseGroupAdmin = !isEnterpriseAccount && isTeamOwner;

  const paidBenchmarksEnabled = preferences?.paidBenchmarksEnabled;
  const plansBenchmarksEnabled = features?.plansBenchmarksEnabled;

  const liteLibraryEnabled = features?.liteLibraryEnabled;
  const libraryEnabled = !!(teamMembership || liteLibraryEnabled);

  const linked = linkedIdentities ?? { totalCount: 0 };
  const hasMultipleLinkedIdentities = linked.totalCount > 1;

  const userLinks = getUserLinks(
    isNonEnterpriseGroupAdmin,
    paidBenchmarksEnabled,
    libraryEnabled,
    plansBenchmarksEnabled,
    isEnterpriseAccount,
    lang,
    isEUDC,
    hasMultipleLinkedIdentities
  );

  return (
    <RenderUserMenu username={parseUsername(username)} menuItems={userLinks} />
  );
};

export default UserMenu;
